import React from 'react';
import './about.css';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

function About() {
    const [ref, isVisible] = useScrollAnimation(0.2);

    return (
        <section className={`about-us fade-in-section ${isVisible ? 'is-visible' : ''}`} id='about-us' ref={ref}>
            <h1>About Us</h1>
            <div className="wrapper about-us">
                <p>
                    For over two decades, Energy Corporation has stood as a pillar of reliability in coal supply and processing. Established 25 years ago, our journey has been one of continuous growth and innovation. The inauguration of our modern coal sizing plant in 2011 allowed us to offer customized coal grades, ensuring optimal performance for our clients' operations. We pride ourselves on our enduring legacy, industry expertise, and our dedication to supporting the energy needs of businesses nationwide.
                </p>
                <div className="whyus">
                    <h2>Why Us?</h2>
                    <p>
                        At Energy Corporation, we stand out from the crowd for several key reasons. We've spent the last 25 years perfecting our craft, ensuring that we not only meet but exceed industry standards. Our coal sizing plant represents the pinnacle of our innovation, offering bespoke coal specifications that precisely fit your needs. When you partner with us, you're choosing a company that prioritizes sustainability, delivers exceptional quality, and provides a level of service that is unmatched in the industry.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default About;
